{
  "name": "@nexa/wallet-sdk-ts",
  "version": "0.1.0",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "source": "src/index.ts",
  "scripts": {
    "build": "parcel build",
    "dev": "parcel watch",
    "test": "vitest run",
    "clean": "rm -rf dist .parcel-cache"
  },
  "repository": {
    "type": "git",
    "url": "git+ssh://git@gitlab.com/nexa/wallet-sdk-ts.git"
  },
  "keywords": [
    "nexa",
    "wallet",
    "web3",
    "crypto",
    "dapp",
    "walletcomms",
    "walletsdk"
  ],
  "contributors": [
    {
      "name": "Dolaned"
    },
    {
      "name": "Griffith"
    },
    {
      "name": "Vgrunner"
    },
    {
      "name": "myendy"
    }
  ],
  "author": "Dolaned",
  "license": "MIT",
  "bugs": {
    "url": "https://gitlab.com/nexa/wallet-sdk-ts/issues"
  },
  "homepage": "https://gitlab.com/nexa/wallet-sdk-ts#readme",
  "description": "Wallet SDK for the Nexa blockchain",
  "devDependencies": {
    "@parcel/packager-ts": "^2.15.4",
    "@parcel/transformer-typescript-types": "^2.15.4",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^22.13.1",
    "parcel": "^2.15.4",
    "typescript": "^5.8.3",
    "vitest": "^3.0.8"
  },
  "targets": {
    "main": {
      "context": "node",
      "outputFormat": "commonjs",
      "distDir": "dist",
      "isLibrary": true,
      "includeNodeModules": [
        "lodash-es"
      ]
    },
    "module": {
      "context": "node",
      "outputFormat": "esmodule",
      "distDir": "dist",
      "isLibrary": true
    },
    "browser": {
      "context": "browser",
      "outputFormat": "esmodule",
      "distDir": "dist",
      "isLibrary": true
    }
  },
  "dependencies": {
    "@vgrunner/electrum-cash": "^2.0.12",
    "bip39": "^3.1.0",
    "js-big-decimal": "^2.2.0",
    "libnexa-ts": "^1.0.5",
    "lodash-es": "^4.17.21"
  },
  "directories": {
    "test": "tests"
  }
}
